{
    "NavigationAll": "Tudo",
    "NavigationReporting": "Comunicando",
    "NavigationAdministration": "Administração",
    "NavigationProvisioning": "Provisionamento",
    "NavigationDevices": "Dispositivos",
    "NavigationEndpoints": "Pontos de extremidade",
    "NavigationTrunking": "Entroncamento",
    "NavigationHospitality": "Hospitalidade",
    "NavigationTrunkgateways": "Gateways de tronco",
    "NavigationVoicemailservices": "Serviços de correio de voz",
    "NavigationConferencedevices": "Dispositivos de conferência",
    "NavigationAgents": "Agentes",
    "NavigationDirectory": "Diretório",
    "NavigationCodes": "Códigos",
    "NavigationPartitions": "Partições",
    "NavigationTelephonyservers": "Servidores de telefonia",
    "NavigationCmenvironments": "Ambientes de gerenciamento central",
    "NavigationApplicationusers": "Usuários do aplicativo",
    "NavigationOmnichannel": "Omnicanal",
    "NavigationRecording": "Gravação",
    "NavigationMessages": "Mensagens",
    "NavigationDatabase": "Base de dados",
    "NavigationStatustools": "Status e ferramentas",
    "NavigationLicenses": "Licenças",
    "NavigationLogging": "Exploração madeireira",
    "NavigationLogmanagement": "Gerenciamento de registros",
    "NavigationAudittrail": "Trilha de auditoria",
    "NavigationTelephonemodulestatus": "Status do Módulo de Telefone",
    "NavigationOmnichannelmodulestatus": "Status do Omnicanal",
    "NavigationCallcontrol": "Controle de chamadas",
    "NavigationServerstatus": "Status do servidor",
    "NavigationNewAnalytics": "Adicionar empresa corporativa",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Conhecimentos",
    "Presence": "Presença",
    "NavigationUserManagement": "Gestão de utilizadores",
    "NavigationManageUsersDevice": "Gerenciar usuários",
    "NavigationEasyProvisioning": "Provisionamento fácil",
    "NavigationManageQueues": "Gerenciar filas"
}